import { getListstStore } from "@/store/lists/actions";
import { useSelector } from "react-redux";
import { map } from "lodash-es";

enum CategoryOptions {
    Lists = 'Lists'
}

export const useContactLists = () => {
    const { listNamesCollection } = useSelector(getListstStore);

    return map(listNamesCollection, (list) => ({
        label: list.ListName,
        category: CategoryOptions.Lists,
        id: list.PublicListID
    }));
}